import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicInputMaskDirective } from './ionic-input-mask.directive';

@NgModule({
  declarations: [
    IonicInputMaskDirective,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    IonicInputMaskDirective,
  ],
})
export class IonicInputMaskDirectiveModule { }
